<template>
    <div class="swiper-wrapper">
        <div class="swiper-slide flex flex-col"
            v-for="post in printedPosts"
            :key="post.ID"
        >
            <a class="flex flex-col"
                :href="post.link"
            >
                <div class="relative w-full overflow-hidden rounded-fix rounded-md mb-7 pb-[100%] | sm:rounded-[14px] sm:mb-5 | md:mb-6 | xxl:mb-9">
                    <!-- <img class="absolute left-0 top-0 w-full h-full object-cover object-center" :src="post.image.sizes.large" :alt="post.image.alt" v-if="post.image && !post.media_type"> -->
                    <ImageBG :image="post.image" class="absolute left-0 top-0 w-full h-full object-cover object-center" v-if="post.image && !post.media_type"></ImageBG>
                    <video v-else muted playsinline loop :src="post.video" class="absolute left-0 top-0 w-full h-full object-cover object-center"></video>
                </div>

                <div class="sm:w-full">
                    <div class="flex flex-wrap">
                        <div 
                            class="label mr-2 mb-5 | sm:mb-3 | md:mb-7 | lg:mb-5 | xxl:mb-6" 
                            :class="{'label--yellow' : type.slug === 'dojo', 'label--blue' : type.slug !== 'dojo'}"
                            v-for="type in post.types"
                            :key="type.id"
                            v-html="type.name"
                        ></div>
                    </div>

                    <h4 class="text-20 mb-6 | sm:mb-4 | md:mb-5 md:mr-[34px] | lg:text-25 lg:mr-11 lg:mb-4 | xxl:text-30 xxl:mr-0 xxl:mb-6"
                        v-html="post.title">
                    </h4>

                    <p class="text-16 sm:text-13 lg:text-16 xxl:text-base" v-html="dateFormat(post.interval_dates)"></p>
           
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import ImageBG from './partials/imageBG.vue'
import moment from 'moment';

const INPUT_DATE_FORMAT = 'DD-MM-YYYY';

export default {
    data() {
        return {
            isActiveEventsArchive: true,
            perPage: parseInt(this.postsPerPage),
            lastItem: parseInt(this.postsPerPage),
            posts: this.json,
            step: parseInt(this.loadStep),
            today: new Date(),
        }
    },

    props: {
        json: [Object, Array],
        postsPerPage: [Number, String]
    },

    created() {
    },

    computed: {
        postsList() {
            let posts = this.posts;

            // Hide passed by events
            posts = posts.filter(post => {
                // check event type
                if (post.type === 'recurring') {
                    let momentStartDate = moment(post.reccuring_data.date,INPUT_DATE_FORMAT),
                        momentEndDate = moment(post.reccuring_data.date,INPUT_DATE_FORMAT).add(post.reccuring_data.duration, 'M');

                    // Add Date intervals
                    let loopedTime = momentStartDate.clone();
                    post.interval_dates = [momentStartDate.format()];

                    switch (post.reccuring_data.repeat_every) {
                        case 'per_week':
                            while (loopedTime.add(1, 'w').isSameOrBefore(momentEndDate)) {
                                post.interval_dates.push(loopedTime.clone().format());
                            }
                            break;
                        case '2_weeks':
                            while (loopedTime.add(2, 'w').isSameOrBefore(momentEndDate)) {
                                post.interval_dates.push(loopedTime.clone().format());
                            }
                            break;
                        case '3_weeks':
                            while (loopedTime.add(3, 'w').isSameOrBefore(momentEndDate)) {
                                post.interval_dates.push(loopedTime.clone().format());
                            }
                            break;
                        default:
                            while (loopedTime.add(1, 'w').isSameOrBefore(momentEndDate)) {
                                post.interval_dates.push(loopedTime.clone().format());
                            }
                            break;
                    }

                    // Add Custom dates
                    const customDates = post.reccuring_data.custom_dates;
                    if (customDates) {
                        for (const customDate of customDates) {
                            post.interval_dates.push(moment(customDate.custom_date,INPUT_DATE_FORMAT).format());
                        }
                    }

                    // Set Nearest past and current dates
          
                    post.interval_dates = post.interval_dates.map((x) => {
                        return moment(x);
                    }).sort((x, y) => {
                        return x.diff(y)
                    });
        
                    let nearestStart = post.interval_dates.find((x) => {
                        return x.isSameOrAfter();
                    });

                    let nearestPastStart = post.interval_dates.reverse().find((x) => {
                        return x.isBefore();
                    });
      
                    // Set event as future/past
                    if (this.isActiveEventsArchive) {
                        post.start_date = nearestStart;
                        return post.interval_dates.some(date => moment(date).isAfter(this.today))
                    } else {
                        post.start_date = nearestPastStart;
                        return post.interval_dates.some(date => moment(date).isSameOrBefore(this.today))
                    }

                } else {

                    const today = moment(this.today,INPUT_DATE_FORMAT).format('YYYY-MM-DD');
                    
                    post.interval_dates = [];

                    if(post.normal_dates && post.normal_dates.dates){
                        post.interval_dates = post.normal_dates.dates.map((x) => {
                            return moment(x.date,INPUT_DATE_FORMAT);
                        }).sort((x, y) => {
                            return x.diff(y)
                        });
                    }
                    
                    let nearestStart = post.interval_dates.find((x) => {
                        return x.isSameOrAfter();
                    });

                    let nearestPastStart = post.interval_dates.reverse().find((x) => {
                        return x.isBefore();
                    });
                    
                    if (this.isActiveEventsArchive) {
                        post.start_date = nearestStart;
                        return post.interval_dates.some(date => moment(date).isAfter(this.today))
                    } else {
                        post.start_date = nearestPastStart;
                        return post.interval_dates.some(date => moment(date).isSameOrBefore(this.today))
                    }
                }

            })

            // Sort Upcoming events by closest date
            posts = posts.sort((firstEvent, secondEvent) => {
                let dateFirst = false;
                let dateSecond = false;
                
                // Duration
                let today = moment(this.today,INPUT_DATE_FORMAT).format('YYYY-MM-DD');

                let datesFirst = firstEvent.interval_dates.filter(item => {
                    if ( moment(item).isSameOrAfter(today) ) {
                        return item;
                    }
                }).sort((x, y) => {
                    return x.diff(y)
                });

                dateFirst = datesFirst[0];
                
                let datesSecond = secondEvent.interval_dates.filter(item => {
                    if ( moment(item).isSameOrAfter(today) ) {
                        return item;
                    }
                }).sort((x, y) => {
                    return x.diff(y)
                });

                dateSecond = datesSecond[0];

                return dateFirst.diff(dateSecond);
            });
            
            // Return posts with all filters and sorted
            return posts;
        },

        printedPosts() {
            return this.postsList;
        },
    },

    methods: {
         dateFormat(date) {
            // for (let index = 0; index < date.length; index++) {
            //     if ( this.today <= date[index] ) {
            //         // console.log(date[index])
            //     }
            //     // const element = array[index];
                
            // }

            let today = moment(this.today).format('YYYY-MM-DD');

            let dates = date.filter(item => {
                if ( moment(item).isSameOrAfter(today) ) {
                    return item;
                }
            }).sort((x, y) => {
                return x.diff(y)
            });

            // console.log(moment(this.today).format('YYYY-MM-DD'));
            
            return moment(dates[0]).format('MMM DD, YYYY');

            // let nearestStart = date.find((x) => {
            //     return x.isSameOrAfter(this.today);
            // });

            // console.log(nearestStart)
            // console.log(this.today)
            // console.log(date);
        //    return moment(date).format('MMM DD, YYYY');
        },
    },
    components: {
        ImageBG
    },
}
</script>

<style lang="scss">
</style>